<template>
  <!-- <div> -->
  <!-- <v-text-field>
            {{ddd}}
          </v-text-field> -->

  <div
    id="te"
    aria-live="polite"
    class="layout message-list column fill-height"
    ref="te"
  >
    <!-- 'margin-bottom' : message.id === text && message.id !== 0 && Focus? '30vw' :'' -->
    <!-- <yd-infinitescroll
    :pullcallback="pullcallback"
    :callback="false"
    ref="infinitescrollDemo"
        >
        <div slot='list'> -->

    <van-pull-refresh
      v-model="loadings"
      @refresh="onRefresh"
      :disabled="isRefreshDisable"
      success-text="刷新成功"
      :loading-icon-size="80"
    >
    <template #pulling>
        <img
      class="loadingGif"
      :src="LoadingGif"
    />
    </template>
     <template #loosing>
        <img
      class="loadingGif"
      :src="LoadingGif"
    />
    </template>
      <!-- 加载提示 -->
      <template #loading>
        <img
      class="loadingGif"
      :src="LoadingGif"
    />
        <!-- <van-loading type="spinner" color="#1989fa" >2222</van-loading>
     -->
        <!-- <div :style="{ display: 'flex', 'align-items': 'center' }">
          <svg
            class="loading"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
          >
            <circle
              class="circle"
              cx="25"
              cy="25"
              r="9"
              fill="none"
              stroke-width="1"
              stroke="#000"
            />
          </svg>
          <div :style="{ marginBottom: '-2vw', 'margin-left': '-2vw' }">22</div>
        </div> -->
      </template>
      <div v-scroll>
        <message
      v-bind:toolbar-logo="toolbarLogo"
          v-scroll
          id="message"
          ref="messages"
          v-for="message in messages"
          v-bind:message="message"
          :key="message.id"
          v-bind:class="`message-${message.type}`"
          v-on:scrollDown="scrollDown"
          :isTextFocus="isTextFocus"
        ></message>
      </div>

      <!-- </div> -->
      <!-- </yd-infinitescroll> -->

      <v-flex v-scroll>
                    <div v-if="loading">
                       <message-loading   v-bind:message= "messages" ></message-loading>  
                    </div>
     
      </v-flex>
    </van-pull-refresh>
  </div>
  <!-- </div> -->
</template>

<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
import Message from "./Message";
import MessageLoading from './MessageLoading.vue'
import YdInfinitescroll from "@/components/InfiniteScroll";
import Bus from "./bus.js";
import { Loading } from "vant";
// import MessageLoading from './MessageLoading.vue';


export default {
  name: "message-list",
  props: ["isTextFocus", "message","toolbarLogo", "LoadingGif"],
  data() {
    return {
      
      isRefreshDisable: false,
      refreshDisabled: false,
      scrollTop: 0,
      tag: 0,
      loadings: true,
      count: 0,
      usrIdd: 0,
      pullcallback: true,
      scroll: "",
      token: "",
      onLine: true,
      originalHeight: 0,
      isiOS: false,
      Focus: this.isTextFocus,
      // text: this.this.$store.state.messages.length - 1,
      queryParams: {
        content: { aa: "bb", cc: "dd" },
        timeStamp: 1663570225258,
        timeZone: "+8",
      },
      queryParams1: {
        content: { aa: "bb", cc: "dd" },
        timeStamp: 1663570225258,
        timeZone: "+8",
      },
      msgs: this.messages,
    };
  },
  components: {
    Message,
    MessageLoading,
    YdInfinitescroll,
    Loading,
    MessageLoading,
  },
  computed: {
    messages() {
      return this.$store.state.messages;
    },
    loading() {
      return (
        this.$store.state.lex.isProcessing ||
        this.$store.state.liveChat.isProcessing
      );
    },
  },
  watch: {
     scrollTop(newval) {
      if (newval > 0) {
        this.isRefreshDisable = true
      } else {
        this.isRefreshDisable = false
      }
    },
    // autoscroll message list to the bottom when messages change
    // isTextFocus(newVal) {

    //   this.Focus = newVal;

    //   if ( !this.isiOS && this.Focus ) {
    //            console.log("tanchu-222--");
    //     // this.$refs.te.style.height = 300 + "px";
    //     this.scrollDown();
    //   } else {
    //     this.scrollDown();
    //     // this.$refs.te.style.height = "";
    //   }
    //   this.text = this.$store.state.messages.length - 1;
    //   console.log(
    //     "isTextFocus---",
    //     this.Focus,
    //     this.$store.state.messages.length - 1,
    //     this.message
    //   );
    // },
    messages() {
      // console.log('msg---', this.messages.type)
      // this.scrollDown();
    },
    loading() {
      this.scrollDown();
    },
  },
  mounted() {
    // console.log('toolbarLogo--', this.toolbarLogo)
    // 解决滚动条与下拉的冲突
    this.$nextTick(() => {
      const vantList = document.getElementById('message');
      this.resolveConflict(vantList)
    })
    // const container = this.$refs.te;
    // container.addEventListener(
    //   "scroll",(e) => {
    //     if (e.target.scrollTop == 0) {
    //       console.log("this.scroll---", 44);
    // this.$store.dispatch("test")
    //       this.getNextPageData()
    //     }
    //   },
    //   1000
    // );

    // Bus.$on('clickTitle',data =>{
    //   if(data) {
    //     const container = this.$refs.te;
    //     let timer = setInterval(() => {
    //       let ispeed = Math.floor(-container.scrollTop / 5)
    //     container.scrollTop = container.scrollTop + ispeed

    //     if(container.scrollTop == 0){
    //       clearInterval(timer);
    //     }
    //     },16)

    //   }
    //   console.log('clickTitle---', data)

    // })

    // window.addEventListener("scroll", this.scrollDown);
    this.originalHeight = window.innerHeight;
    window.addEventListener("resize", this.onResize);
    window.addEventListener("online", this.update, false), // 网络由异常到正常时触发
      window.addEventListener("offline", this.update, false); //网络由正常到异常时触发

    // window.addEventListener("touchmove", () => {
    //   // console.log("333");
    //   this.$refs.te.style.height = "";
    //   // console.log("2222",  event.changedTouches[0].pageY);
    // });
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      this.isiOS = true;
    }
    console.log("this.token---", this.token);
    setTimeout(() => {
      this.scrollDown();
    }, 1000);
    // console.log("!~===",this.$i18n.locale );
  },
  directives: {
    scroll: {
      inserted(el) {
        console.log("el---", el);
        el.scrollIntoView();
      },
    },
  },
  beforeDestroy() {
    window.removeEventListener("online", this.update, false);
    window.removeEventListener("offline", this.update, false);
    window.removeEventListener("resize", this.onResize);
  },
  //销毁,否则跳到别的路由还是会出现
  destroyed() {
    window.removeEventListener("scroll", this.scrollDown);
  },
  created() {
      window.setUserInfo = this.setUserInfo;
  },
  methods: {
      resolveConflict(val) {
      const vantList = val
      vantList.addEventListener('touchmove', () => {
        this.scrollTop = vantList.scrollTop
      })
      vantList.addEventListener('touchend', () => {
        this.scrollTop = vantList.scrollTop
      })
    },
    update(res) {
      console.log(res);
      this.onLine = res.type === "online";
      // if (this.onLine) {
      //   console.log("网络正常---", this.$route.query.token);
      // } else if (this.$route.query.token !== "null") {
      //   console.log("网络异常---", this.$route.query.token);
      // }
    },
    onRefresh() {
      const now = new Date().getTime();
      // let newArr = this.$store.state.messages;
      const userid3 = window.localStorage.getItem("userid");
      const valueStore = localStorage.getItem(`store-${userid3}`);
      let intervalTime = -1;
    if (valueStore !== null) {

      const sessionStore = JSON.parse(valueStore);
      let newArr = sessionStore.messages;
      const lastTime = new Date(newArr[newArr.length - 1].date);
       intervalTime = now - lastTime.getTime();
      console.log("lmsg--", this.$store.state.messages, newArr, lastTime, intervalTime);
    }
    
      if (this.onLine === false) {
        // toast({ text: this.$t("licence.key_internet_error"), time: 1000 });
        if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }
      } else {
        setTimeout(() => {
          // showToast('刷新成功');
          if (this.tag === 0 && intervalTime > 100000 || intervalTime  === -1) {
            this.$store.dispatch("reloadMsg");
            this.tag = 1;
          }

          // this.$store.dispatch("initMessageList"),

          this.loadings = false;
          this.count++;
        }, 1000);
      }
    },
    //解密
    decrypt(data) {
      // 十六位十六进制数作为密钥
      const SECRET_KEY = CryptoJS.enc.Utf8.parse("ts*3iuer$g9we8mi");
      // 十六位十六进制数作为密钥偏移量
      const SECRET_IV = CryptoJS.enc.Utf8.parse("");
      const decrypt = CryptoJS.AES.decrypt(data, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      // console.log("查找decryptedStr---", data, decryptedStr);
      // this.$store.state.messages = decryptedStr;
      // console.log("查找decryptedStr--222-",  this.$store.state.messages);
      // this.$store.subscribe((mutation, state) => {
      // sessionStorage.setItem("historyText", JSON.stringify(decryptedStr));
      // });

      return decryptedStr.toString();
    },
    setUserInfo(param) {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      const result = JSON.parse(param);
      if (isiOS) {
        console.log(
          "messagelist---",
          result,
          result.userInfo,
          result.userInfo.token
        );
        this.queryParams = result.userInfo.token;
        if (
          result.userInfo.userId == undefined ||
          result.userInfo.userId == 0
        ) {
          this.usrIdd = 0;
        } else {
          this.usrIdd = result.userInfo.userId;
        }
        console.log("this.queryParams--", this.queryParams);
        this.$emit("sendToken", this.queryParams);
        window.localStorage.setItem("timeZone", result.userInfo.timeZone);
        window.localStorage.setItem("from", result.userInfo.pageType);
        window.localStorage.setItem("lang", result.userInfo.language);
        window.localStorage.setItem("userid", this.usrIdd);
        // window.localStorage.setItem("Name", result.userInfo.accountName);
      } else {
        this.queryParams = result;
        console.log("setUserInfo---", param, result.userId);
        if (result.userId == undefined || result.userId == 0) {
          this.usrIdd = 0;
        } else {
          this.usrIdd = result.userId;
        }
        window.localStorage.setItem("lang", result.language);
        window.localStorage.setItem("from", result.pageType);
        window.localStorage.setItem("timeZone", result.timeZone);
        window.localStorage.setItem("userid", this.usrIdd);
        // window.localStorage.setItem("Name", result.accountName);
      }
      this.$i18n.locale = localStorage.getItem("lang");
      console.log("VueI18n---", this.$i18n.locale);
      // let data = {
      //   'name' : 'xiaoming'
      // };
      return localStorage.getItem("lang");
      // console.log("333---", language);
    },
    onResize() {
      // this.$refs.infinitescrollDemo.$emit('ydui.pullrefresh.finishLoad.success',true)
      //键盘弹起与隐藏都会引起窗口的高度发生变化
      const resizeHeight = window.innerHeight;
      console.log("软键盘弹出---");
      if (this.originalHeight - resizeHeight > 50 && message.length > 1) {
        // this.$refs.te.style.height = 300 + "px";
        this.scrollDown();
        // console.log("tanchu-111--", this.$refs.te.style.height);
      }
    },
    scrollDown() {
      console.log("333");
      //  this.getNextPageData()
      return this.$nextTick(() => {
        // //变量scrollTop是滚动条滚动时，距离顶部的距离
        // let scrollTop = this.$el.scrollTop;
        // //变量windowHeight是可视区的高度
        // let windowHeight = this.$el.clientHeight;
        // //变量scrollHeight是滚动条的总高度
        // let scrollHeight = this.$el.scrollHeight;
        // //滚动条到底部的条件
        // if (scrollTop + windowHeight == scrollHeight) {
        //   // if (this.listData.length < this.total) {
        //   // this.pageNo++
        //   // 获取下一页的数据
        //   console.log("this.scroll---", 44);
        //   // this.getNextPageData()
        //   // }
        // }

        this.scroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        console.log("this.scroll---", this.scroll);
        if (this.$el.lastElementChild) {
          const lastMessageHeight =
            this.$el.lastElementChild.getBoundingClientRect().height;
          const isLastMessageLoading =
            this.$el.lastElementChild.classList.contains("messsge-loading");

          if (isLastMessageLoading) {
            this.$el.scrollTop = this.$el.scrollHeight;
            // console.log('isLastMessageLoading---',this.$el.scrollTop)
          } else {
            this.$el.scrollTop = this.$el.scrollHeight - lastMessageHeight;
            // this.getNextPageData();
            // console.log('isLastMessageLoading-222--',this.$el.scrollTop)
          }
        }
        //  this.getNextPageData()
      });
    },
    getNextPageData() {
      var obj = {
        text: "3333",
        type: "bot",
        date: new Date(),
        is_show_time: true,
      };
      this.$store.state.messages.push(obj);
      console.log("this.scroll---obj---", obj);
    },
  },
};
</script>

<style scoped>
/deep/ .van-pull-refresh {
  height: calc(100vh - 500px) !important;
}
.row-list {
  height: auto !important;
}
/* .loading {
  background-color: red !important;
} */

/deep/.van-pull-refresh__head {
  display: flex;
  justify-content: center;
  align-items: center;
  width: "-webkit-fill-available";
}

.message-list ::-webkit-scrollbar {
  display: none;
}

.message-list {
  padding-top: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.message-bot {
  align-self: flex-start;
}

.message-agent {
  align-self: flex-start;
}

.message-human {
  align-self: flex-end;
}

.message-feedback {
  align-self: flex-end;
}

.loadingGif {
  width: 12vw;
  height: 12vw;
}

.circle {
  animation: loading-dash 1.5s ease-in-out infinite;
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
.loading {
  animation: loading-rotate 2s linear infinite;
}
@keyframes loading-rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>
